"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const H1 = styled_components_1.default.h1 `
  font-weight: 600;
  font-size: 28px;
`;
exports.H1 = H1;
const H2 = styled_components_1.default.h2 `
  font-weight: 600;
  font-size: 24px;
  text-transform: capitalize;
`;
exports.H2 = H2;
const H3 = styled_components_1.default.h3 `
  font-weight: ${(p) => (p.bold ? "600" : "400")};
  font-size: 18px;
`;
exports.H3 = H3;
const H4 = styled_components_1.default.h4 `
  font-weight: ${(p) => (p.$bold ? "700" : "400")};
  font-size: 14px;
  letter-spacing: 0.14px;
`;
exports.H4 = H4;
const H5 = styled_components_1.default.h5 `
  font-weight: ${(p) => (p.bold ? "600" : "400")};
  font-size: 12px;
`;
exports.H5 = H5;
const H6 = styled_components_1.default.h6 `
  font-weight: ${(p) => (p.bold ? "500" : "400")};
  font-size: 10px;
  text-transform: ${(p) => (p.uppercase ? "uppercase" : "none")};
  letter-spacing: ${(p) => (p.uppercase ? "0.1px" : "normal")};
`;
exports.H6 = H6;
